export interface MessageSelectorProps {
    top: number;
    left: number
}

export interface MessageOptionsProps {
    isMouseOver: boolean
}

/** Information to be sent to the MessageDisplay component. */
export interface MessageOption {
    type: Message,
    textOpacity: number
}

/** A Message and its textual content. */
export enum Message {
    hello = "Hi there!",
    ily = "ILY",
    letsChat = "Let's chat!",
    lonely = "I'm lonely...",
    barf = "I'm gonna barf",
    thanks = "Thanks"
}

export type ProximityChatMessage = {
  author: string;
  userName: string;
  townID: string;
  body: Message;
  dateSent: Date;
};
